import { apiClient } from './client';

export interface RoleSummary {
  id: number;
  rolecode: string;
  rolename: string;
  description?: string | null;
  issystem: boolean;
  isdeletable: boolean;
  isactive: boolean;
  memberCount: number;
}

export interface RolePermission {
  modulecode: string;
  modulename: string;
  actions: string[];
}

export interface RoleDetail {
  id: number;
  rolecode: string;
  rolename: string;
  description?: string | null;
  issystem: boolean;
  isdeletable: boolean;
  permissions: RolePermission[];
}

export interface RoleModule {
  id: number;
  modulecode: string;
  modulename: string;
  actions: string[];
  category?: string;
}

export interface RolePermissionInput {
  modulecode: string;
  actions: string[];
}

export interface CreateRoleData {
  rolecode: string;
  rolename: string;
  description?: string;
  permissions: RolePermissionInput[];
}

export interface UpdateRoleData {
  rolename?: string;
  description?: string;
  permissions?: RolePermissionInput[];
}

export class RolesAPI {
  static async getAll() {
    return apiClient.get<RoleSummary[]>('/roles');
  }

  static async getById(id: number) {
    return apiClient.get<RoleDetail>(`/roles/${id}`);
  }

  static async getModules() {
    return apiClient.get<RoleModule[]>('/roles/modules');
  }

  static async create(data: CreateRoleData) {
    return apiClient.post<RoleDetail>('/roles', data);
  }

  static async update(id: number, data: UpdateRoleData) {
    return apiClient.patch<RoleDetail>(`/roles/${id}`, data);
  }

  static async delete(id: number) {
    return apiClient.delete<void>(`/roles/${id}`);
  }
}
